import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Phone } from 'lucide-react';
import ResponsiveImage from '../components/ui/ResponsiveImage.jsx';
import { companyInfo } from '../data.js';
import TaxaCalculator from '../components/TaxaCalculator.jsx';

export default function TaxaPriser() {
  return (
    <div className="pt-32 pb-24">
      <Helmet>
        <title>Taxa Priser | {companyInfo.name}</title>
        <meta name="description" content="Se vores gældende priser for taxa kørsel i Thy og på Mors. Vi tilbyder både lillebil og storbil til konkurrencedygtige priser." />
      </Helmet>

      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="mb-6 text-4xl font-bold tracking-tight text-slate-900 md:text-5xl">
            Taxa Priser
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Som et nyt tiltag tilbyder vi siden d. 17. november 2023 Taxi kørsel. Vi har nu en taxa både i Thy og på Mors, og vores telefon er åben døgnet rundt.
          </p>
        </div>

        <div className="grid gap-12 lg:grid-cols-2">
          {/* Prices */}
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100">
              <h2 className="text-2xl font-bold text-slate-900 mb-6">Lillebil</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-blue-600 mb-3">Dag (Kl. 06.00 – 18.00)</h3>
                  <ul className="space-y-2 text-slate-600">
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Starttakst</span>
                      <span className="font-medium text-slate-900">49,00 kr.</span>
                    </li>
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Kilometertakst</span>
                      <span className="font-medium text-slate-900">12,30 kr.</span>
                    </li>
                    <li className="flex justify-between pb-2">
                      <span>Tidstakst pr. min.</span>
                      <span className="font-medium text-slate-900">6,66 kr.</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-blue-600 mb-3">Nat (Kl. 18.00 – 06.00)</h3>
                  <ul className="space-y-2 text-slate-600">
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Starttakst</span>
                      <span className="font-medium text-slate-900">59,00 kr.</span>
                    </li>
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Kilometertakst</span>
                      <span className="font-medium text-slate-900">13,74 kr.</span>
                    </li>
                    <li className="flex justify-between pb-2">
                      <span>Tidstakst pr. min.</span>
                      <span className="font-medium text-slate-900">7,50 kr.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-100">
              <h2 className="text-2xl font-bold text-slate-900 mb-6">Storbil</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-blue-600 mb-3">Dag (Kl. 06.00 – 18.00)</h3>
                  <ul className="space-y-2 text-slate-600">
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Starttakst</span>
                      <span className="font-medium text-slate-900">69,00 kr.</span>
                    </li>
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Kilometertakst</span>
                      <span className="font-medium text-slate-900">17,00 kr.</span>
                    </li>
                    <li className="flex justify-between pb-2">
                      <span>Tidstakst pr. min.</span>
                      <span className="font-medium text-slate-900">6,66 kr.</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-blue-600 mb-3">Nat (Kl. 18.00 – 06.00)</h3>
                  <ul className="space-y-2 text-slate-600">
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Starttakst</span>
                      <span className="font-medium text-slate-900">79,00 kr.</span>
                    </li>
                    <li className="flex justify-between border-b border-slate-50 pb-2">
                      <span>Kilometertakst</span>
                      <span className="font-medium text-slate-900">19,25 kr.</span>
                    </li>
                    <li className="flex justify-between pb-2">
                      <span>Tidstakst pr. min.</span>
                      <span className="font-medium text-slate-900">7,50 kr.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
              <h2 className="text-xl font-bold text-slate-900 mb-4">Særlige tillæg</h2>
              <ul className="space-y-3 text-slate-600">
                <li className="flex items-center gap-3">
                  <span className="h-2 w-2 rounded-full bg-blue-600"></span>
                  Transport af cykel (kun ved forudbestilling): 30 kr.
                </li>
                <li className="flex items-center gap-3">
                  <span className="h-2 w-2 rounded-full bg-blue-600"></span>
                  Transport af kørestolsbrugere: 100 kr.
                </li>
                <li className="flex items-center gap-3">
                  <span className="h-2 w-2 rounded-full bg-blue-600"></span>
                  Rengøring efter opkast: 1.500 kr.
                </li>
              </ul>
            </div>
          </div>

          {/* Image and Contact */}
          <div className="space-y-8">
            <ResponsiveImage 
              src="https://assets.auxodev.dk/assets/80af3c4d-4953-436f-a9f5-4abfeafc9910/8435e7b9-b9de-49e2-8a78-0014c67ffe21.jpg" 
              alt="Taxa priser" 
              className="w-full rounded-3xl object-cover shadow-lg"
              sizes="(max-width: 1024px) 100vw, 500px"
            />
            
            <div className="bg-blue-600 text-white p-8 rounded-3xl text-center">
              <h2 className="text-2xl font-bold mb-4">Bestil din taxa nu</h2>
              <p className="text-blue-100 mb-6">Vores telefon er åben døgnet rundt.</p>
              <a 
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="inline-flex items-center gap-3 bg-white text-blue-600 px-8 py-4 rounded-full text-xl font-bold transition-transform hover:scale-105"
              >
                <Phone className="h-6 w-6" />
                {companyInfo.phone}
              </a>
            </div>
          </div>
        </div>

        {/* Calculator Section */}
        <div id="beregn-pris" className="mt-16 pt-16 border-t border-slate-100 scroll-mt-32">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-slate-900">Prisberegner</h2>
            <p className="text-slate-600 mt-2">Brug vores beregner til at estimere prisen på din tur ud fra de gældende takster.</p>
          </div>
          <TaxaCalculator />
        </div>
      </div>
    </div>
  );
}
